export function splitModelIdentifier(input: string): { model: string; body: string } {
  let body = '';
  let model = '';
  if (input === 'DISABLED') return { model, body };
  if (!input.includes('_')) {
    body = input;
    return { model, body };
  }
  const parts = input.split('_');
  model = `${parts[0]}_${parts[1]}`;
  body = parts.slice(2).join('_');
  return { model, body };
}

export function removeClassSuffixForOneSearch(value: string | undefined): string {
  return value?.split('_')[0] ?? '';
}
